import _regeneratorRuntime from "/root/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

import { fork, call, take } from 'redux-saga/effects';
/**
 * Implementation of `takeLeading` from `redux-saga`.
 * @todo Replace `takeLeading` with effect from `redux-saga` once v1 is released
 */

export default (function (pattern, saga) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return fork(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var action;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!true) {
              _context.next = 8;
              break;
            }

            _context.next = 3;
            return take(pattern);

          case 3:
            action = _context.sent;
            _context.next = 6;
            return call.apply(void 0, [saga].concat(_toConsumableArray(args.concat(action))));

          case 6:
            _context.next = 0;
            break;

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
});